import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { COUNT_FUNERAL_SERVICES } from '../queries/funeralServices';

export const countFuneralServices = async (id) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: { id },
      query: COUNT_FUNERAL_SERVICES,
    });
    return response.data.defuntos.count;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
